// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Map_tooltip__2L70X","marker":"Map_marker__13n6H"};